(function () {
  const money = (cents) => `$${(Number(cents || 0) / 100).toFixed(2)}`;
  const moneyCompact = (cents) => {
    const value = Number(cents || 0) / 100;
    return Number.isInteger(value) ? `$${value}` : `$${value.toFixed(2)}`;
  };

  const openCartDrawer = () => {
    const drawer = document.querySelector('[data-hwd-cart-drawer]');
    const overlay = document.querySelector('[data-hwd-cart-overlay]');
    if (!drawer || !overlay) return false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('hidden');
    document.body.classList.add('hwd-cart-open');
    return true;
  };

  const refreshCartDrawer = async () => {
    try {
      const response = await fetch(`/?sections=cart-drawer&hwdpdp_cart=${Date.now()}`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) return openCartDrawer();
      const sections = await response.json();
      const html = sections['cart-drawer'];
      if (!html) return openCartDrawer();
      const wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      const next = wrapper.querySelector('#shopify-section-cart-drawer');
      const current = document.querySelector('#shopify-section-cart-drawer');
      if (next && current) current.replaceWith(next);
      return openCartDrawer();
    } catch (error) {
      return openCartDrawer();
    }
  };

  const toast = (() => {
    let node = document.querySelector('[data-hwdpdp-toast]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'hwdpdp-toast';
      node.setAttribute('data-hwdpdp-toast', '');
      document.body.appendChild(node);
    }
    let timer;
    return (message) => {
      node.textContent = message;
      node.classList.add('is-visible');
      window.clearTimeout(timer);
      timer = window.setTimeout(() => node.classList.remove('is-visible'), 1800);
    };
  })();

  const switchGalleryToImage = (source, imageSrc, imageId, label) => {
    if (!imageSrc) return;
    const shell = source.closest?.('.hwdpdp-shell') || document.querySelector('.hwdpdp-shell');
    const main = shell?.querySelector('[data-hwdpdp-gallery-main]');
    const thumbs = shell?.querySelector('[data-hwdpdp-gallery-thumbs]');
    if (!main) return;

    const safeId = imageId || `option-${String(imageSrc).split('/').pop() || Date.now()}`;
    const existingSlide = main.querySelector(`[data-hwdpdp-media-id="${CSS.escape(safeId)}"]`);
    if (existingSlide) {
      const slides = Array.from(main.children);
      const index = Math.max(0, slides.indexOf(existingSlide));
      main.scrollTo({ left: index * main.clientWidth, behavior: 'smooth' });
      if (thumbs) {
        thumbs.querySelectorAll('[data-hwdpdp-thumb-index]').forEach((thumb, thumbIndex) => {
          thumb.classList.toggle('on', thumbIndex === index);
        });
      }
      return;
    }

    let dynamicSlide = main.querySelector('[data-hwdpdp-option-photo]');
    if (!dynamicSlide) {
      dynamicSlide = document.createElement('div');
      dynamicSlide.className = 'ph';
      dynamicSlide.setAttribute('data-hwdpdp-option-photo', '');
      main.prepend(dynamicSlide);
    }
    dynamicSlide.setAttribute('data-hwdpdp-media-id', safeId);
    dynamicSlide.replaceChildren();

    const img = document.createElement('img');
    img.src = imageSrc;
    img.alt = label || 'Selected His Word Daily option';
    img.loading = 'eager';
    dynamicSlide.appendChild(img);

    const count = document.createElement('span');
    count.className = 'gallery-count';
    count.textContent = 'Selected';
    dynamicSlide.appendChild(count);

    main.scrollTo({ left: 0, behavior: 'smooth' });
    thumbs?.querySelectorAll('[data-hwdpdp-thumb-index]').forEach((thumb) => thumb.classList.remove('on'));
  };

  const initGallery = (root) => {
    const main = root.querySelector('[data-hwdpdp-gallery-main]');
    const thumbs = root.querySelector('[data-hwdpdp-gallery-thumbs]');
    if (!main || !thumbs) return;
    const thumbButtons = Array.from(thumbs.querySelectorAll('[data-hwdpdp-thumb-index]'));
    const updateThumb = () => {
      const index = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
      thumbButtons.forEach((button, buttonIndex) => button.classList.toggle('on', buttonIndex === index));
    };
    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const index = Number(button.getAttribute('data-hwdpdp-thumb-index') || 0);
        main.scrollTo({ left: index * main.clientWidth, behavior: 'smooth' });
      });
    });
    main.addEventListener('scroll', updateThumb, { passive: true });
    updateThumb();
  };

  const initAccordions = (root) => {
    root.querySelectorAll('[data-hwdpdp-accordion] .acc-item').forEach((item) => {
      const head = item.querySelector('.acc-head');
      const body = item.querySelector('.acc-body');
      if (!head || !body) return;
      const setHeight = () => {
        body.style.maxHeight = item.classList.contains('open') ? `${body.scrollHeight}px` : '0px';
      };
      head.addEventListener('click', () => {
        item.classList.toggle('open');
        setHeight();
      });
      setHeight();
      window.addEventListener('resize', setHeight);
    });
  };

  const initVariantButtons = (form) => {
    const variantInput = form.querySelector('[data-hwdpdp-variant-id]');
    const selectedOutput = form.querySelector('[data-hwdpdp-selected-option]');
    const priceOutput = document.querySelector('[data-hwdpdp-price]');
    const stickyPrice = document.querySelector('[data-hwdpdp-sticky-price]');
    const totalOutput = form.querySelector('[data-hwdpdp-total]');
    const bundleTotalOutput = form.querySelector('[data-hwdpdp-bundle-total]');
    const quantityInput = form.querySelector('[data-hwdpdp-quantity]');
    let unitPrice = Number(form.querySelector('[data-hwdpdp-variant-option].on')?.getAttribute('data-variant-price') || form.getAttribute('data-hwdpdp-base-price') || 0);
    let comparePrice = Number(form.querySelector('[data-hwdpdp-variant-option].on')?.getAttribute('data-variant-compare') || form.getAttribute('data-hwdpdp-base-compare') || 0);

    const switchGalleryToVariant = (button) => {
      const imageId = button.getAttribute('data-variant-image-id');
      const imageSrc = button.getAttribute('data-variant-image-src');
      if (!imageId || !imageSrc) return;

      switchGalleryToImage(
        form,
        imageSrc,
        imageId,
        `${form.getAttribute('data-hwdpdp-product-title') || 'His Word Daily product'} - ${button.getAttribute('data-variant-title') || 'selected option'}`
      );
    };

    const renderProductPrice = () => {
      if (!priceOutput || !unitPrice) return;
      const hasCompare = comparePrice && comparePrice > unitPrice;
      priceOutput.innerHTML = `${hasCompare ? `<span class="hwdpdp-product-value__compare">${money(comparePrice)}</span>` : ''}<strong class="hwdpdp-product-value__price">${money(unitPrice)}</strong>`;
    };

    const qty = () => Math.max(1, Number(quantityInput?.value || 1));
    const addOnTotal = () => {
      let total = 0;
      const engraving = form.querySelector('[data-hwdpdp-engraving]');
      const engravingToggle = engraving?.querySelector('[data-hwdpdp-engraving-toggle]');
      if (engraving && engravingToggle?.checked) total += Number(engraving.getAttribute('data-engraving-price') || 0) * qty();
      const dailyUpgradeVariant = Number(form.getAttribute('data-hwdpdp-daily-upgrade-variant-id') || 0);
      const dailyUpgradeButton = form.querySelector('[data-hwdpdp-upgrade="daily-rhythm-hoodie"].on');
      if (dailyUpgradeVariant && dailyUpgradeButton) {
        total += Number(dailyUpgradeButton.getAttribute('data-hwdpdp-upgrade-price') || 0) * qty();
      }
      const sticker = form.querySelector('[data-hwdpdp-sticker-addon]');
      const range = sticker?.querySelector('[data-hwdpdp-extra-stickers-range]');
      if (sticker && range) total += Number(sticker.getAttribute('data-extra-sticker-price') || 0) * Math.max(0, Number(range.value || 0));
      return total;
    };
    const updateTotals = () => {
      const fullTotal = (unitPrice * qty()) + addOnTotal();
      renderProductPrice();
      if (stickyPrice && unitPrice) stickyPrice.textContent = money(unitPrice);
      if (totalOutput && unitPrice) totalOutput.textContent = money(fullTotal);
      if (bundleTotalOutput && unitPrice) bundleTotalOutput.textContent = money(fullTotal);
    };

    form.querySelectorAll('[data-hwdpdp-variant-option]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        form.querySelectorAll('[data-hwdpdp-variant-option]').forEach((sibling) => sibling.classList.remove('on'));
        button.classList.add('on');
        unitPrice = Number(button.getAttribute('data-variant-price') || unitPrice);
        comparePrice = Number(button.getAttribute('data-variant-compare') || 0);
        if (variantInput) variantInput.value = button.getAttribute('data-variant-id');
        if (selectedOutput) selectedOutput.textContent = button.getAttribute('data-variant-title') || button.textContent.trim();
        switchGalleryToVariant(button);
        updateTotals();
      });
    });

    return updateTotals;
  };

  const initAddOns = (form, updateTotals) => {
    const engraving = form.querySelector('[data-hwdpdp-engraving]');
    const engravingToggle = engraving?.querySelector('[data-hwdpdp-engraving-toggle]');
    const engravingName = form.querySelector('[data-hwdpdp-engraving-name]');
    if (engravingToggle && engravingName) {
      engravingToggle.addEventListener('change', () => {
        engravingName.disabled = !engravingToggle.checked;
        if (!engravingToggle.checked) engravingName.value = '';
        updateTotals?.();
      });
      engravingName.addEventListener('input', () => updateTotals?.());
    }

    const sticker = form.querySelector('[data-hwdpdp-sticker-addon]');
    const range = sticker?.querySelector('[data-hwdpdp-extra-stickers-range]');
    const output = sticker?.querySelector('[data-hwdpdp-extra-stickers-output]');
    const costOutput = sticker?.querySelector('[data-hwdpdp-extra-stickers-cost]');
    const stickerPrice = Number(sticker?.getAttribute('data-extra-sticker-price') || 0);
    if (range) {
      const update = () => {
        const extra = Math.max(0, Number(range.value || 0));
        if (output) output.textContent = String(extra);
        if (costOutput) costOutput.textContent = moneyCompact(extra * stickerPrice);
        updateTotals?.();
      };
      range.addEventListener('input', update);
      update();
    }
  };

  const initQuantity = (form, updateTotals) => {
    const input = form.querySelector('[data-hwdpdp-quantity]');
    const value = form.querySelector('[data-hwdpdp-qty-value]');
    if (!input || !value) return;
    const setQty = (next) => {
      const quantity = Math.min(10, Math.max(1, Number(next || 1)));
      input.value = String(quantity);
      value.textContent = String(quantity);
      if (updateTotals) updateTotals();
    };
    form.querySelector('[data-hwdpdp-qty-minus]')?.addEventListener('click', () => setQty(Number(input.value) - 1));
    form.querySelector('[data-hwdpdp-qty-plus]')?.addEventListener('click', () => setQty(Number(input.value) + 1));
    setQty(input.value);
  };

  const initPropertyButtons = (form) => {
    const updateStepCompletion = (step) => {
      if (!step || step.classList.contains('config-step--static')) return true;
      const requiredInputs = Array.from(step.querySelectorAll('[data-property-input][data-property-required="true"]'));
      const isComplete = requiredInputs.length
        ? requiredInputs.every((input) => String(input.value || '').trim())
        : Boolean(step.querySelector('[data-property-button].on'));
      step.classList.toggle('is-complete', isComplete);
      return isComplete;
    };

    const updateRequiredSelectionState = () => {
      const requiredSteps = Array.from(form.querySelectorAll('.config-step:not(.config-step--static)'));
      if (!requiredSteps.length) return true;
      const isReady = requiredSteps.every((step) => updateStepCompletion(step));
      const submitButtons = [form.querySelector('[type="submit"]')];
      if (form.id) {
        document.querySelectorAll(`[data-hwdpdp-submit="#${CSS.escape(form.id)}"]`).forEach((button) => submitButtons.push(button));
      }
      submitButtons.filter(Boolean).forEach((button) => {
        if (!button.dataset.readyLabel) button.dataset.readyLabel = button.textContent.trim() || 'Add to cart';
        button.disabled = !isReady;
        button.textContent = isReady ? button.dataset.readyLabel : 'Choose options';
        button.classList.toggle('is-disabled', !isReady);
      });
      form.toggleAttribute('data-hwdpdp-requires-selection', true);
      form.toggleAttribute('data-hwdpdp-ready', isReady);
      return isReady;
    };

    form.querySelectorAll('[data-property-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.getAttribute('data-property-button');
        const value = button.getAttribute('data-property-value');
        if (!key || !value) return;
        form.querySelectorAll(`[data-property-button="${CSS.escape(key)}"]`).forEach((sibling) => sibling.classList.remove('on'));
        button.classList.add('on');
        const input = form.querySelector(`[data-property-input="${CSS.escape(key)}"]`);
        const output = form.querySelector(`[data-property-output="${CSS.escape(key)}"]`);
        if (input) input.value = value;
        if (output) output.textContent = value;
        const step = button.closest('.config-step');
        const propertyImage = button.getAttribute('data-property-image-src');
        if (propertyImage) {
          switchGalleryToImage(form, propertyImage, `property-${key}-${value}`, value);
        }
        updateStepCompletion(step);
        updateRequiredSelectionState();
        form.dispatchEvent(new CustomEvent('hwdpdp:update-totals', { bubbles: true }));
      });
    });

    form.querySelectorAll('.config-step').forEach((step) => {
      if (step.classList.contains('config-step--static')) {
        step.classList.add('is-complete');
      } else {
        updateStepCompletion(step);
      }
    });

    updateRequiredSelectionState();
  };

  const initCountdowns = () => {
    document.querySelectorAll('[data-hwdpdp-countdown]').forEach((root) => {
      const hours = root.querySelector('[data-hwdpdp-countdown-hours]');
      const minutes = root.querySelector('[data-hwdpdp-countdown-minutes]');
      const seconds = root.querySelector('[data-hwdpdp-countdown-seconds]');
      if (!hours || !minutes || !seconds) return;

      const pad = (value) => String(value).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const next = new Date(now);
        next.setHours(24, 0, 0, 0);
        const diff = Math.max(0, next.getTime() - now.getTime());
        const totalSeconds = Math.floor(diff / 1000);
        hours.textContent = pad(Math.floor(totalSeconds / 3600));
        minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
        seconds.textContent = pad(totalSeconds % 60);
      };

      tick();
      window.setInterval(tick, 1000);
    });
  };

  const initStickyBar = () => {
    const sticky = document.querySelector('[data-hwdpdp-sticky]');
    if (!sticky) return;
    const firstForm = document.querySelector('[data-hwdpdp-cart-form]');
    const submitButton = sticky.querySelector('[data-hwdpdp-submit]');
    submitButton?.addEventListener('click', () => {
      const selector = submitButton.getAttribute('data-hwdpdp-submit');
      const form = selector ? document.querySelector(selector) : firstForm;
      if (form) form.requestSubmit();
    });
    const target = firstForm?.querySelector('.add-cart') || firstForm;
    if (!target || !('IntersectionObserver' in window)) {
      sticky.classList.add('show');
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      sticky.classList.toggle('show', !entry.isIntersecting);
    }, { threshold: 0.15 });
    observer.observe(target);
  };

  const initForms = () => {
    document.querySelectorAll('[data-hwdpdp-cart-form]').forEach((form) => {
      const updateTotals = initVariantButtons(form);
      initQuantity(form, updateTotals);
      form.addEventListener('hwdpdp:update-totals', () => updateTotals?.());
      initPropertyButtons(form);
      initAddOns(form, updateTotals);
      updateTotals?.();
    });
  };

  const propertiesFromForm = (form) => {
    const properties = {};
    const data = new FormData(form);
    data.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)]$/);
      if (!match) return;
      const clean = String(value || '').trim();
      if (clean) properties[match[1]] = clean;
    });
    return properties;
  };

  const extraCartItems = (form, mainQuantity, productTitle) => {
    const items = [];
    const engraving = form.querySelector('[data-hwdpdp-engraving]');
    const engravingToggle = engraving?.querySelector('[data-hwdpdp-engraving-toggle]');
    const engravingName = form.querySelector('[data-hwdpdp-engraving-name]');
    if (engraving && engravingToggle?.checked) {
      const name = String(engravingName?.value || '').trim();
      if (!name) {
        engravingName?.focus();
        throw new Error('Add the name to engrave');
      }
      items.push({
        id: Number(engraving.getAttribute('data-engraving-variant-id')),
        quantity: mainQuantity,
        properties: {
          For: productTitle,
          Name: name,
          _hwd_addon: 'tumbler-name-engraving',
        },
      });
    }

    const sticker = form.querySelector('[data-hwdpdp-sticker-addon]');
    const range = sticker?.querySelector('[data-hwdpdp-extra-stickers-range]');
    const extra = Math.max(0, Number(range?.value || 0));
    if (sticker && extra > 0) {
      items.push({
        id: Number(sticker.getAttribute('data-extra-sticker-variant-id')),
        quantity: extra,
        properties: {
          For: productTitle,
          _hwd_addon: 'extra-share-the-word-sticker',
        },
      });
    }
    const dailyUpgradeVariant = Number(form.getAttribute('data-hwdpdp-daily-upgrade-variant-id') || 0);
    const dailyUpgradeButton = form.querySelector('[data-hwdpdp-upgrade="daily-rhythm-hoodie"].on');
    if (dailyUpgradeVariant && dailyUpgradeButton) {
      items.push({
        id: dailyUpgradeVariant,
        quantity: mainQuantity,
        properties: {
          For: productTitle,
          _hwd_addon: 'daily-rhythm-hoodie-upgrade',
        },
      });
    }
    return items.filter((item) => item.id && item.quantity > 0);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-hwdpdp-cart-form]');
    if (!form) return;
    event.preventDefault();

    if (form.hasAttribute('data-hwdpdp-requires-selection') && !form.hasAttribute('data-hwdpdp-ready')) {
      toast('Choose your bundle options first');
      const firstIncomplete = form.querySelector('.config-step:not(.config-step--static):not(.is-complete)');
      firstIncomplete?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const button = form.querySelector('[type="submit"]');
    const original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding';
    }

    try {
      const formData = new FormData(form);
      const mainId = Number(formData.get('id'));
      const quantity = Math.max(1, Number(formData.get('quantity') || 1));
      const productTitle = form.getAttribute('data-hwdpdp-product-title') || 'His Word Daily product';
      const items = [{
        id: mainId,
        quantity,
        properties: propertiesFromForm(form),
      }, ...extraCartItems(form, quantity, productTitle)];

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('Add to cart failed');
      await response.json();
      window.location.href = '/cart';
    } catch (error) {
      if (error.message === 'Add the name to engrave') {
        toast(error.message);
        return;
      }
      form.submit();
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = original || 'Add to cart';
      }
    }
  });

  const init = () => {
    document.querySelectorAll('.hwdpdp-shell').forEach((root) => {
      initGallery(root);
      initAccordions(root);
    });
    initForms();
    initStickyBar();
    initCountdowns();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
